import { getPdfImageType } from "./sf009FormSignatureUtils";

export { getPdfImageType };
export const MAX_DIAGRAM_IMAGE_BYTES = 5 * 1024 * 1024;

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("Failed to read image file"));
    reader.readAsDataURL(file);
  });
}

export function normalizeImageSource(value, fallbackMime = "image/jpeg") {
  if (!value) return "";
  let src = value;
  if (Array.isArray(src)) src = src[0];
  if (src == null) return "";
  if (typeof src !== "string") src = String(src);
  src = src.trim();
  if (!src) return "";
  if (src.startsWith("data:image")) return src;
  if (/^(https?:)?\/\//i.test(src)) return src;
  const compact = src.replace(/\s+/g, "").replace(/,+$/, "");
  if (!compact) return "";
  let mime = fallbackMime;
  if (compact.startsWith("/9j")) mime = "image/jpeg";
  else if (compact.startsWith("iVBOR")) mime = "image/png";
  else if (compact.startsWith("R0lGOD")) mime = "image/gif";
  else if (compact.startsWith("UklGR")) mime = "image/webp";
  return `data:${mime};base64,${compact}`;
}

export function normalizeDiagramImages(value) {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.map((v) => normalizeImageSource(v)).filter(Boolean);
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith("[")) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) return normalizeDiagramImages(parsed);
      } catch {}
    }
    const single = normalizeImageSource(trimmed);
    return single ? [single] : [];
  }
  return [];
}

export function addDiagramImagesToPdf(doc, diagramList, opts) {
  const {
    contentX,
    contentW,
    yPosition: startY,
    pageHeight,
    pageBottom = 32,
    themeRgb = [139, 22, 52],
  } = opts;
  const list = normalizeDiagramImages(diagramList);
  if (!list.length) return startY;

  let yPosition = startY;
  const cols = list.length === 1 ? 1 : 2;
  const gap = 6;
  const cellW = (contentW - (cols - 1) * gap) / cols;
  const cellH = list.length === 1 ? 90 : 58;

  if (yPosition + 24 > pageHeight - pageBottom) {
    doc.addPage();
    yPosition = 14;
  }

  doc.setTextColor(...themeRgb);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text(`Diagram / attachments (${list.length})`, contentX, yPosition + 5);
  yPosition += 10;

  let rowStartY = yPosition;
  for (let i = 0; i < list.length; i += 1) {
    const col = i % cols;
    if (col === 0 && i > 0) rowStartY += cellH + gap;
    if (rowStartY + cellH > pageHeight - pageBottom) {
      doc.addPage();
      rowStartY = 14;
    }
    const x = contentX + col * (cellW + gap);
    doc.setDrawColor(220, 220, 220);
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(x, rowStartY, cellW, cellH, 2, 2, "FD");
    try {
      const imgType = getPdfImageType(list[i], "JPEG");
      doc.addImage(list[i], imgType, x + 2, rowStartY + 2, cellW - 4, cellH - 4, "", "NONE");
    } catch {}
  }
  return rowStartY + cellH + 8;
}
